export default __webpack_public_path__ + "88c84dfb355968ff492185d6afa2140a.jpeg";